module.exports = __webpack_public_path__ + "static/media/add.190ac05d.svg";